<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-System-Aggregator-Create",
  path: "create",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
